import { forwardRef, ReactNode } from 'react';
import Box, { BoxProps } from '@mui/material/Box';

export interface BoxComponentProps extends Omit<BoxProps, 'children'> {
  children?: ReactNode;
  component?: React.ElementType;
  value?: string | number;
  disabled?: boolean;
  src?: string;
  alt?: string;
}

export function BoxComponent({ children, ...otherProps }: BoxComponentProps) {
  return <Box {...otherProps}>{children}</Box>;
}

// Forward the ref properly
export const BoxComponentRef = forwardRef<HTMLDivElement, BoxComponentProps>(({ children, ...otherProps }, ref) => {
  return (
    <Box ref={ref} {...otherProps}>
      {children}
    </Box>
  );
});

BoxComponentRef.displayName = 'BoxComponent'; // For better debugging in React DevTools
